module.exports = __webpack_public_path__ + "static/media/loader.78822c4d.gif";